import { CapacityOverrideModule } from './capacity-override/capacity-override.module';
import { DealershipHolidaysModule } from './../dealership-holidays/dealership-holidays.module';
import { DealershipCapacityModule } from './dealership-capacity/dealership-capacity.module';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ServiceAdvisorModule } from './service-advisor/service-advisor.module';
import { TeamManagementModule } from './team-management/team-management.module';
import { ServiceSettingsModule } from './service-settings/service-settings.module';
import { OpcodeServiceManagementModule } from './opcode-service-management/opcode-service-management.module';
import { ServiceScheduleModule } from './service-schedule/service-schedule.module';
import { TransportCapacityModule } from './transport-capacity/transport-capacity.module';
import { ServiceScheduleDashboardModule } from './service-schedule-dashboard/service-schedule-dashboard.module';
import { AspRoles, AspSalesAdminRoles, AspServiceAdminRolesT2,AspServiceAdminRoles } from '../shared/services/util.service';
import { aspAuthenticationGuardService } from '../shared/guards/auth.guard';
import { TxmManagementModule } from './txm-management/txm-management.module';
import { ProtectRoute } from '../shared/guards/protect-route.guard';

const routes: Routes = [
    {
        path: '',
        canActivate:[ProtectRoute],
        children: [
            {
                path: '',
                redirectTo: 'scheduledashboard',
                pathMatch: 'prefix'
            },
            {
                path: 'settings',
                loadChildren: () => ServiceSettingsModule,
                data: { roles: [...AspRoles,  ...AspServiceAdminRoles] },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'manageadvisors',
                loadChildren: () => ServiceAdvisorModule,
                data: { roles: [...AspRoles,  ...AspServiceAdminRoles] },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'managecapacity',
                loadChildren: () => DealershipCapacityModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles, ...AspServiceAdminRolesT2] },
                canActivateChild: [aspAuthenticationGuardService]

            },
            {
                path: 'managetransportcapacity',
                loadChildren: () => TransportCapacityModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles] },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'capacityoverride',
                loadChildren: () => CapacityOverrideModule,

            },
            {
                path: 'manageholidays',
                loadChildren: () => DealershipHolidaysModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles, ...AspServiceAdminRolesT2] },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'teammanagement',
                loadChildren: () => TeamManagementModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles,  ...AspServiceAdminRolesT2] },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'opcodeservicemanagement',
                loadChildren: () => OpcodeServiceManagementModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles,  ...AspServiceAdminRolesT2] },
            },
            {
                path: 'schedulerotation',
                loadChildren: () => ServiceScheduleModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles,  ...AspServiceAdminRolesT2] },
                canActivateChild: [aspAuthenticationGuardService]
            },
            {
                path: 'scheduledashboard',
                loadChildren: () => ServiceScheduleDashboardModule
            },
            {
                path: 'txm',
                loadChildren: () => TxmManagementModule,
                data: { roles: [...AspRoles, ...AspServiceAdminRoles,  ...AspServiceAdminRolesT2] },
                canActivateChild: [aspAuthenticationGuardService]
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ServiceRoutingModule { }
